import { AssetDetailsResponse } from '../types';
import { baseClient } from './client/instance';

const path = 'media-assets';

export const createMediaAssets = async (data: FormData) => {
  const response = await baseClient.post<AssetDetailsResponse>(path, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};
